<template>
  <account-owner-security-information-edit />
</template>

<script>
import AccountOwnerSecurityInformationEdit from "@/components/3pl/Settings/AccountProfile_/AccountOwner/EditSecuritySettings/index";
export default {
  components: {
    AccountOwnerSecurityInformationEdit,
  },
};
</script>

<style></style>
